//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Block text title
     */
    title: {
      type: String,
      default: null
    },
    /**
     * Whether the title is bold
     */
    titleBold: {
      type: Boolean,
      default: false
    },
    /**
     * Block text body
     */
    body: {
      type: String,
      required: true
    },
    /**
     * Block text body
     */
    bodyColor: {
      type: String,
      default: '#000000'
    },
    /**
     * Block text size: md | lg
     */
    size: {
      type: String,
      default: 'md',
      validator: val => ['sm', 'md', 'lg', 'xlg'].includes(val)
    },
    /**
     * Block items alignment: left | center
     */
    alignment: {
      type: String,
      default: 'start',
      validator: val => ['start', 'center'].includes(val)
    },
    /**
     * Image items alignment: top | left | right
     */
    slotPosition: {
      type: String,
      default: 'top',
      validator: val => ['top', 'left', 'right', 'bottom'].includes(val)
    }
  },
  computed: {
    cssClasses () {
      return [
        'base-block-text',
        'd-flex',
        `text-${this.alignment}`,
        `align-items-${this.alignment}`, {
          'base-block-text--sm': this.isSmall,
          'base-block-text--md': this.isMedium,
          'base-block-text--lg': this.isLarge,
          'base-block-text--xlg': this.isXLarge,
          'flex-row': ['left', 'right'].includes(this.slotPosition),
          'justify-content-between': ['left', 'right'].includes(this.slotPosition),
          'flex-column': ['top', 'bottom'].includes(this.slotPosition)
        }
      ]
    },
    cssVars () {
      return {
        '--body-color': this.bodyColor
      }
    },
    cssSlotClasses () {
      return {
        'order-1': this.slotPosition === 'right'
      }
    },
    cssContentClasses () {
      return {
        'pl-24': this.slotPosition === 'left',
        'pr-24': this.slotPosition === 'right',
        'd-flex': ['left', 'right'].includes(this.slotPosition),
        'flex-column': ['left', 'right'].includes(this.slotPosition),
        'justify-content-between': ['left', 'right'].includes(this.slotPosition),
        'h-100': ['left', 'right'].includes(this.slotPosition),
        'order-first': this.slotPosition === 'bottom'
      }
    },
    isMedium () {
      return this.size === 'md'
    },
    isLarge () {
      return this.size === 'lg'
    },
    isSmall () {
      return this.size === 'sm'
    },
    isXLarge () {
      return this.size === 'xlg'
    }
  }
}
